import React, { Component } from 'react'
import { Switch, Route } from 'react-router-dom'

import FullPageComponents from '../FullPageComponents'
import News from '../News'

class Routes extends Component {

  render() {
    return (
      <Switch>
        <Route path="/:title" component={News}/>
        <Route path="/" component={FullPageComponents} />
      </Switch>
    )
  }
}


export default Routes



// WEBPACK FOOTER //
// ./src/components/Router/index.js